import { JObject } from "../../../../common/data/models"
import { TopupPartnerDto } from "../../domain/dtos/topup-partner";

export const TopupPartnerMapper = {
    /**
     * Create cart model from json object
     * @param json
     * @returns {TopupPartnerDto}
     */
    toDto: (json: JObject): TopupPartnerDto => {
        return {
            partnerId: json.partnerId,
            partnerName: json.partnerName,
            partnerType: json.partnerType,
            logoContent: json?.logoContent,
            businessType: json.businessType,
            channel: json.channel,
            instructionUrl: json.instructionUrl,
            maximumTopUp: json.maximumTopUp,
            minimumTopUp: json.minimumTopUp,
            siteId: json.siteId,
            terms: json.terms,
            topUpPartnerId: json.topUpPartnerId,
            topUpThroughUs: json.topUpThroughUs
        }
    },
}
